import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../features/iso27001/security/securityApi';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Footer } from '../components/Footer';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tokenFromUrl = searchParams.get('token') ?? '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!tokenFromUrl) {
      setError('Enlace inválido o incompleto');
      return;
    }
    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);
    try {
      const result = await resetPassword(tokenFromUrl, newPassword);
      if (!result.success) {
        setError(result.message);
        return;
      }
      navigate('/login', { replace: true, state: { message: result.message } });
    } catch (err: unknown) {
      const axiosErr = err as { response?: { data?: { message?: string } } };
      setError(axiosErr.response?.data?.message || 'No se pudo restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <div className='flex flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
          <h2 className='text-center text-2xl font-bold text-foreground'>Nueva contraseña</h2>
        </div>
        <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-card px-6 py-8 shadow-sm rounded-lg border'>
          <form onSubmit={(e) => void handleSubmit(e)} className='space-y-4'>
            <Input
              type='password'
              placeholder='Nueva contraseña'
              autoComplete='new-password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
            />
            <Input
              type='password'
              placeholder='Confirmar contraseña'
              autoComplete='new-password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
            />
            {error && <p className='text-sm text-red-500'>{error}</p>}
            <Button type='submit' className='w-full' disabled={loading}>
              {loading ? 'Guardando...' : 'Restablecer contraseña'}
            </Button>
            <p className='text-center text-sm'>
              <Link to='/login' className='text-primary hover:underline'>
                Volver al inicio de sesión
              </Link>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
